import { render } from "./ProfileProposalsList.vue?vue&type=template&id=ce2da034&scoped=true"
import script from "./ProfileProposalsList.vue?vue&type=script&lang=js"
export * from "./ProfileProposalsList.vue?vue&type=script&lang=js"

import "./ProfileProposalsList.vue?vue&type=style&index=0&id=ce2da034&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce2da034"]])

export default __exports__